import { combineReducers } from "redux";
import authSlice from "./auth/authSlice";
import languageSlice from "./languages/languageSlice";

// Layout
import Layout from "./layout/reducer";
import loadingSlice from "./loading/loadingSlice";

const rootReducers = combineReducers({
  // public
  Layout,
  auth: authSlice,
  loading: loadingSlice,
  language: languageSlice,
});

export default rootReducers;
